export const COOKIE_TOKEN = "hexa-token";
export const COOKIE_REFRESH_TOKEN = "hexa-refresh-token";
export const COOKIE_USER_ID = "hexa-user-id";
export const COOKIE_SESSION_VERSION = "hexa-session-version";
